import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathEquals: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-equals, ="><path d="M4.75 9.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 14.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMathEquals;
